import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-8">
          观影指南
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.slice(0, 3).map((card, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/70 p-5 hover:border-primary-200 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mb-4">
                <i className={`${card.icon} text-primary-600 text-lg`}></i>
              </div>
              <span className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-2 whitespace-nowrap">
                {card.tag}
              </span>
              <h3 className="text-sm font-medium text-foreground-800 mb-2">{card.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cardItems.slice(3, 5).map((card, i) => (
            <div
              key={i + 3}
              className="bg-background-50 rounded-lg border border-background-200/70 p-5 hover:border-primary-200 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                <i className={`${card.icon} text-accent-600 text-lg`}></i>
              </div>
              <span className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-2 whitespace-nowrap">
                {card.tag}
              </span>
              <h3 className="text-sm font-medium text-foreground-800 mb-2">{card.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}